import { doPost, doPost2 } from './common'

/*

*/

export const start = (breakId, stepId) => {
    // console.log(breakId)

    let payload = {
        breakId: breakId,
        stepId: stepId,
        stepType: 'lead'
    }

    return doPost(`/lead/start`, payload);

}

export const complete = (breakId, stepId, stepSkipped) => {

    let payload = {
        breakId: breakId,
        stepId: stepId,
        skipped: stepSkipped
    }

    return doPost(`/lead/complete`, payload);

}

// returns a promise
export const submit = (leadId, breakId, stepId, fields) => {
    let payload = {
        breakId: breakId,
        stepId: stepId,
        leadId: leadId,
        ...fields
    }

    return doPost2(`/lead/submit/`, payload);

}

//This is gross, I know, but Paul wanted a new payload mapping.
//https://api-2020.dailybreak.com/api/static/redoc.html#operation/processBlueBuffaloLeadSubmission
export const buffaloSubmit = (args) => {
    let payload = args
    return doPost(`/lead/submitBlueBuffalo/`, payload);

}